import siteInfo from './siteinfo.js'
export default class Util{
	constructor() {
	}
	
	/**
	 * 获取静态资源文件地址【在服务器端的静态资源】
	 * @param {String} url 资源名称
	 */
	getStaticSrc(url){
		let { siteroot } = siteInfo.siteInfo
		let src = siteroot.split('//')[0]+'//'+siteroot.split('//')[1].split('/')[0]+'/mini/'		
		return src+url
	}
	
	getUniacid(){
		return siteInfo.siteInfo.uniacid
	}
	
	/**
	 * 数据类型判断
	 * @param {Object} data
	 */
	dealData(data){
		if( data ){
			//数据为Array 类型
			if( typeof data == 'array'){
				if( data.length > 0 ){	//判断数据是否为空数组
					return data
				}
				return null
			}
			
			if( typeof data == 'object' ){
				if( JSON.stringify(data)==="{}" ){  //判断对象是否为空对象
					return null
				}
				return data
			}
			return data
		}
		return null
	}
	
	/**
	 * 验证手机号
	 * @param {Object} $phone
	 */
	isPhoneAvailable($phone) {
		var myreg=/^[1][3,4,5,7,8,9][0-9]{9}$/;
		if (!myreg.test($phone)) {
			return false;
		}
		return true;
	}
	
	
	/**
	 * 十六进制颜色转rgb颜色
	 * @param {Object} color【#fff or #ffffff => rbg(225,225,225)】
	 */
	colorRgb(color){
		// 16进制颜色值的正则
		var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
		// 把颜色值变成小写
		color = color.toLowerCase();
		if (reg.test(color)) {
			// 如果只有三位的值，需变成六位，如：#fff => #ffffff
			if (color.length === 4) {
				var colorNew = "#";
				for (var i = 1; i < 4; i += 1) {
					colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
				}
				color = colorNew;
			}
			// 处理六位的颜色值，转为RGB
			var colorChange = [];
			for (var i = 1; i < 7; i += 2) {
				colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
			}
			return colorChange.join(",");
		}
		return color;
	}
}


// WEBPACK FOOTER //
// ./src/util/util.js